<tt-page *ngIf="!!get">
    <div>
        <tt-page-heading>
            <span class="tt-drawer-button far fa-bars" (click)="toggleFolderPane()"></span>
            {{ get.selected_folder_name }} ({{ get.current_mailbox }})
        </tt-page-heading>
    </div>
    <tt-toast *ngIf="account === null" class="col-xs-12 sp-0" ttType="danger" ttTitle="w_email_not_signed_in_microsoft" ttTranslateTitle></tt-toast>
    <tt-divider ttRememberId="w_email.dividers" class="flex-1 height-full" style="overflow: auto">
        <tt-divider-columns>
            <tt-divider-pane ttSize="30" [ttExpanded]="get.folders_is_expanded == '1'">
                <tt-card>
                    <mgt-login #login></mgt-login>
                    <tt-select *ngIf="!!this.get" ttLabel="mailboxes" ttLabelView="none" [(ttModel)]="get.current_mailbox" (ttModelChange)="onMailboxChanged()" [ttData]="sharedMailboxes"></tt-select>
                    <tt-email-mail-folders *ngIf="!!get" [get]="get" (selectedFolderChange)="onMailFolderChanged($event)"></tt-email-mail-folders>
                </tt-card>
            </tt-divider-pane>
            <tt-divider-pane ttSize="70">
                <tt-divider-columns>
                    <tt-divider-pane ttSize="50">
                        <div class="flex-column height-full">
                            <tt-card ttClass="w_email__search">
                                <ng-container *ngIf="!!get">
                                    <tt-select
                                        [ttRememberId]="'w_email.local_search.' + get.current_account_email"
                                        ttLabel="local_search"
                                        ttLabelView="none"
                                        [(ttModel)]="get.local_search"
                                        (ttModelChange)="onSearchFolderChanged()"
                                        [ttData]="folderSearchOptions"
                                        ttClearValue=""
                                    ></tt-select>
                                    <tt-input
                                        [ttRememberId]="'w_email.email_search_global.' + get.current_account_email"
                                        ttLabel="email_search_global"
                                        ttLabelView="none"
                                        [(ttModel)]="get.email_search_global"
                                        (ttModelChange)="onEmailSearchChanged()"
                                        ttDebounceTime="500"
                                        ttShowClearButton
                                    ></tt-input>
                                </ng-container>
                            </tt-card>
                            <tt-tabs ttRememberId="w_email.gb_email_main" [(ttSelectedId)]="get.gb_email_main" (ttSelectedIdChange)="onTabChanged()">
                                <tt-tab ttId="FOCUSED" ttLabel="w_email_inference_focused"></tt-tab>
                                <tt-tab ttId="OTHER" ttLabel="w_email_inference_other"></tt-tab>
                                <tt-tab ttId="ALL" ttLabel="w_email_inference_all"></tt-tab>
                                <tt-tab ttId="LAST_ARCHIVED" ttLabel="w_email_last_archived"></tt-tab>
                            </tt-tabs>
                            <tt-grid class="flex-1" [hidden]="get.gb_email_main === 'LAST_ARCHIVED'" [(ttOptions)]="grid" (ttReady)="setInitialDataToGrid()"></tt-grid>
                            <tt-grid class="flex-1" *ngIf="!!gridLastArchived" [hidden]="get.gb_email_main !== 'LAST_ARCHIVED'" [(ttOptions)]="gridLastArchived"></tt-grid>
                        </div>
                    </tt-divider-pane>
                    <tt-divider-pane ttSize="20" [ttExpanded]="get.gb_email_main !== 'LAST_ARCHIVED'">
                        <span *ngIf="!email" style="height: 100%; display: flex; align-items: center; justify-content: center">
                            <span class="fad fa-mail-bulk" style="color: var(--tt-link-color); font-size: 12.8rem"></span>
                        </span>
                        <div *ngIf="!!email" style="display: flex; flex-direction: column">
                            <div class="w_email__form--actions">
                                <tt-button
                                    [ngClass]="{ 'w_email__form-action--hidden': !get.auto_archieve_folder_id || get.auto_archieve_folder_id == '0' }"
                                    ttIcon="fa-fw far fa-folder-upload"
                                    ttTooltipText="w_email_move_to_archive"
                                    (ttClick)="moveSelectedEmailToArchiveFolder()"
                                ></tt-button>
                                <tt-button ttIcon="fa-fw far fa-reply" ttTooltipText="w_email_reply" (ttClick)="replyEmail(email.email_keyno)"></tt-button>
                                <tt-button ttIcon="fa-fw far fa-reply-all" ttTooltipText="w_email_reply_all" (ttClick)="replyAllEmail(email.email_keyno)"></tt-button>
                                <tt-button
                                    [ttIcon]="'' + email.pers_no > '0' ? 'fa-fw far fa-user-check' : ' fa-fw far fa-user'"
                                    [ttType]="'' + email.pers_no > '0' ? 'success' : 'primary'"
                                    ttTooltipText="w_email_open_personinfo"
                                    (ttClick)="openEmailPersonInfoForm()"
                                ></tt-button>
                                <tt-button
                                    ttIcon="fa-fw far fa-archive"
                                    ttTooltipText="w_email_open_archive"
                                    [ttType]="'' + email.exist_in_email_archive === '1' ? 'success' : 'primary'"
                                    (ttClick)="openEmailArchiveForm()"
                                ></tt-button>
                                <tt-button ttIcon="fa-fw fas fa-waveform-path fa-fw" ttType="warning" ttTooltipText="w_email_mark_as_spam" (ttClick)="markSelectedEmailAsSpam()"></tt-button>
                                <tt-button ttIcon="fa-fw fas fa-trash fa-fw" ttType="danger" ttTooltipText="w_email_delete" (ttClick)="deleteSelectedEmail()"></tt-button>
                            </div>
                            <tt-document-viewer-legacy
                                [ttModel]="email"
                                ttIsEmail="true"
                                ttEmailShowSentData="true"
                                ttEmailAttachmentsView="inline"
                                [ttEmailAttachments]="email.attachments ?? []"
                                (ttEmailAttachmentClick)="openFileAttachment($event)"
                                [ttEmailButtons]="emailViewButtons"
                                style="flex: 1"
                            ></tt-document-viewer-legacy>
                        </div>
                        <!-- <tt-email-viewer *ngIf="!!email" [ttEmail]="email" [ttAttachments]="email.attachments"></tt-email-viewer> -->
                    </tt-divider-pane>
                </tt-divider-columns>
            </tt-divider-pane>
            <!-- <tt-divider-pane ttSize="15">
                <tt-card *ngIf="!!email" ttClass="height-full">
                    <!-- <div class="w_email__form--actions">
                        <tt-button
                            [ngClass]="{ 'w_email__form-action--hidden': !get?.auto_archieve_folder_id || get?.auto_archieve_folder_id == '0' }"
                            ttIcon="far fa-folder-upload"
                            ttTooltipText="w_email_move_to_archive"
                            (ttClick)="moveSelectedEmailToArchiveFolder()"
                        ></tt-button>
                        <tt-button ttIcon="fas fa-waveform-path fa-fw" ttType="warning" ttTooltipText="w_email_mark_as_spam" (ttClick)="markSelectedEmailAsSpam()"></tt-button>
                        <tt-button ttIcon="fas fa-trash fa-fw" ttType="danger" ttTooltipText="w_email_delete" (ttClick)="deleteSelectedEmail()"></tt-button>
                    </div> -->
            <!--  <tt-email-archive-form
                        [showCreateVoucher]="get?.show_buttons_accounting === '1'"
                        [archiveHeading]="get?.heading_email_archiving ?? ''"
                        [email]="email"
                        (emailArchived)="onEmailArchived($event)"
                    ></tt-email-archive-form>
                </tt-card>
            </tt-divider-pane> -->
        </tt-divider-columns>
    </tt-divider>
</tt-page>
<tt-card>
    <tt-button-goto
        ttText="email_account_shared"
        ttGoto="emailaccountshared"
        [ttGotoParms]="{ current_account_email: get?.current_account_email }"
        [ttDisabled]="!get?.current_account_email"
    ></tt-button-goto>
    <tt-button-settings *ngIf="!!get && get.show_setting === '1'"></tt-button-settings>
</tt-card>
<header class="w_email__header col-xs-12 sp-0">
    <tt-card>
        <ng-container *ngIf="!!get">
            <tt-search
                ttLabel="email_auto_archieve_folder_id"
                [(ttModel)]="get.auto_archieve_folder_name"
                ttMinLength="0"
                [ttSearch]="searchArchiveMailFolders"
                (ttOnSelected)="onArchiveFolderSelected($event)"
                (ttOnClear)="onArchiveFolderSelected()"
            ></tt-search>
        </ng-container>
        <!-- <mgt-login #login></mgt-login> -->
    </tt-card>
    <tt-card>
        <ng-container *ngIf="!!get">
            <tt-select
                [ttRememberId]="'w_email.businessco_no.' + get.current_account_email"
                ttLabel="businessco_no"
                [(ttModel)]="get.businessco_no"
                (ttModelChange)="onBusinessCoChanged($event)"
                [ttData]="companies"
                ttDataId="businessco_no"
                ttDataName="company_name"
            ></tt-select>
        </ng-container>
        <!-- <tt-list *ngIf="!!this.get" ttRadioSelection [(ttSelectedId)]="this.get.current_mailbox" (ttRadioSelectionChanged)="onMailboxChanged()" [ttData]="sharedMailboxes"></tt-list> -->
    </tt-card>
    <!-- <tt-card> -->
    <!-- <tt-search
            ttLabel="email_auto_archieve_folder_id"
            [(ttModel)]="get.auto_archieve_folder_name"
            ttMinLength="0"
            ttFilterOperation="filter"
            [ttData]="mailFolders"
            (ttOnSelected)="onArchiveFolderSelected($event)"
            (ttOnClear)="onArchiveFolderSelected()"
        ></tt-search>
        <tt-select
            [ttRememberId]="'w_email.businessco_no.' + get.current_account_email"
            ttLabel="businessco_no"
            [(ttModel)]="get.businessco_no"
            (ttModelChange)="onBusinessCoChanged($event)"
            [ttData]="companies"
            ttDataId="businessco_no"
            ttDataName="company_name"
        ></tt-select> -->
    <!-- </tt-card> -->
    <tt-card>
        <tt-select
            *ngIf="!!get"
            ttRememberId="w_email.retrieve_max_nbr_of_emails"
            ttLabel="email_get_amount_of_emails"
            [(ttModel)]="get.retrieve_max_nbr_of_emails"
            (ttModelChange)="reloadGridData()"
            [ttData]="emailPageSizes"
        ></tt-select>
    </tt-card>
</header>
<!-- 
tt-email-show-sent-data="false" tt-email-attachments-view="inline" tt-email-attachments="vm.model.selectedEmail.attachments" tt-email-attachment-click="vm.openFileInNewTab(attachment)" -->
